import { Injectable } from '@angular/core';
import {HttpParams} from "@angular/common/http";
import {HttpClientService} from "./http-client.service";

@Injectable({
  providedIn: 'root'
})
export class AlertaService {

  constructor(private http: HttpClientService) { }

  public getByIdProyecto(proyectoID: string) {
    let params = new HttpParams().set("proyectoID",proyectoID);
    return this.http.getWithParams('/alerta/getbyidproyecto', params);
  }

  public getByIDProyectoPaginated(proyectoID: string, page) {
    let params = new HttpParams().set("proyectoID",proyectoID).set("page",page);
    return this.http.getWithParams('/alerta/getbyidproyectopaginated', params);
  }

  public getCountByIDProyecto(proyectoID: string) {
    let params = new HttpParams().set("proyectoID",proyectoID);
    return this.http.getWithParams('/alerta/getcountbyidproyecto', params);
  }

  public changeEstado(idAlerta: string, estado: boolean) {
    let json =
      {
        "idAlerta": idAlerta,
        "estado": estado
      };
    return this.http.post('/alerta/changeestado', JSON.stringify(json));
  }

  public getPresenciasByIdProyecto(proyectoID: string) {
    let params = new HttpParams().set("proyectoID",proyectoID);
    return this.http.getWithParams('/alerta/getpresenciasbyidproyecto', params);
  }

  getPresenciasByTimestamps(MAC, time_init, time_end) {
    let params = new HttpParams().set("idDispositivo", MAC).set("time_init", time_init).set("time_end", time_end);
    return this.http.getWithParams('/alerta/getpresenciasbytimestamps', params);
  }

}
